import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { Message } from '../models/message.model';


@Injectable({
  providedIn: 'root'
})
export class ContextDiscoveryEventBusService {

  constructor() { }
  private serverMessageSource = new Subject<Message>();

  serverMessage$ = this.serverMessageSource.asObservable();

  sendMessage(message: Message) {
    this.serverMessageSource.next(message);
  }
}
